import React from 'react';
import './sasuwi.css';

const SASUWI = () => {
  return (
    <div>
      <div className="header-container">
        <img 
          src="/CW_HORIZONTAL_WHITE.png" 
          alt="Commonwealth Secretariat Logo" 
          className="header-logo1"

        />
        <h1 className="header-title">Commonwealth Secretariat - SAS Joint Initiative</h1>
        <img 
          src="/sas-logo-white.png" 
          alt="SAS Logo" 
          className="header-logo"
        />
      </div>

      <div className="sasuwi-container">
        <section className="sasuwi-header">
          <h1>Empowering Digital Innovation Across the Commonwealth</h1>
          <p className="intro-text">
            A groundbreaking partnership between the Commonwealth Secretariat and SAS to unlock the transformative 
            potential of AI and advanced analytics across 56 Commonwealth countries, bridging the digital divide and 
            fostering innovation.
          </p>
        </section>

        <section className="quote-section">
          <div className="quote-content">
            <div className="quote-text-content">
              <blockquote>
                "Digital readiness is essential – and the cornerstone of this readiness is the digital capabilities 
                of our young people. That is why our SAS Digital Literacy Initiative focuses on students and educators. 
                This critical demographic has too often been overlooked or taken for granted in the drive to bridge 
                the digital divide, but it is key to catalysing the spirit of innovation across our member states."
              </blockquote>
            </div>
            <div className="quote-author-section">
              <img 
                src="/team/picture 11-1400w.png" 
                alt="Commonwealth Secretary-General" 
                className="author-avatar"
              />
              <div className="author-info">
                <span className="author-name">Rt Hon Patricia Scotland KC</span>
                <span className="author-title">Commonwealth Secretary-General</span>
              </div>
            </div>
          </div>
        </section>

        <section className="why-section">
          <h2>Key Focus Areas</h2>
          <div className="feature-list">
            <div className="feature-item">
              <img src="/sas-img-0.jpg" alt="Policy Development" style={{width: '100%', height: '200px', objectFit: 'cover', borderRadius: '8px'}} />
              <h3>Digital Literacy & Education</h3>
              <p>Empowering students and educators with AI and analytics capabilities through comprehensive training programs and educational resources.</p>
            </div>
            <div className="feature-item">
              <img src="/sas-viya-logo.png" alt="Research and Innovation" style={{width: '100%', height: '200px', objectFit: 'cover', borderRadius: '8px'}} />
              <h3>Innovation & Technology Access</h3>
              <p>Providing access to SAS Viya, Microsoft Azure cloud platform, and 15 cutting-edge tools for visual analytics and model management.</p>
            </div>
            <div className="feature-item">
              <img src="/ethical-ai.png" alt="Resource Library" style={{width: '100%', height: '200px', objectFit: 'cover', borderRadius: '8px'}} />
              <h3>Ethical AI Development</h3>
              <p>Fostering responsible AI practices through dedicated training modules, ethical guidelines, and hands-on experience in developing AI solutions that prioritize societal impact.</p>
            </div>
          </div>
        </section>

        <section className="highlight-quote-section">
          <div className="quote-card">
            <p className="quote-text">"Students will learn how to wield these powerful technologies ethically, in ways that benefit society."</p>
            <div className="quote-author">
              <span className="author-name1">Reggie Townsend</span>
              <span className="author-title1">Vice President of Data Ethics, SAS</span>
            </div>
          </div>
        </section>

        <section className="showcase-section">
          <h2 style={{marginBottom: '1.5rem'}}>Initiative Highlights</h2>
          <ul className="why-section" style={{paddingLeft: '1.5rem'}}>
            <li>Partnership with The University of the West Indies, serving 18 Caribbean countries</li>
            <li>Access to SAS Viya and Microsoft Azure cloud platform</li>
            <li>International AI competitions for practical experience</li>
            <li>Support from the Commonwealth Artificial Intelligence Consortium (CAIC)</li>
            <li>Focus on responsible and ethical use of AI</li>
          </ul>
        </section>

        <div className="cta-message">
          <h3>Get Involved</h3>
          <p>Join thousands across the Commonwealth in this transformative digital initiative. Whether you're a student, 
             educator, or institution, there are numerous ways to participate:</p>
          <ul>
            <li>Access to SAS Viya and advanced analytics tools</li>
            <li>Participate in international AI competitions</li>
            <li>Join training programs and workshops</li>
            <li>Collaborate on research projects</li>
          </ul>
          <div className="cta-buttons">
            <a 
              href="https://www.sas.com/content/sascom/en_us/offers/24q4/commonwealth-ai-initiative.html" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="register-button"
            >
              Register Here
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SASUWI;
